import React, { Component } from 'react';
import { userService } from "../../../_services";
import search_icon from "../../../images/search_icon.png";
import exportIcon from '../../../images/export.svg';
import Pagination from '../Group_no/pagination';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import copy from 'copy-to-clipboard';

class DashboardUsageReport extends Component {
    constructor(props) {
        var yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        var today = new Date();
        super(props);
        this.state = {
            startDate: new moment(yesterday).format("MM/DD/YYYY"),
            endDate: new moment(today).format("MM/DD/YYYY"),
            usageList: [],
            usageListTemp: [],
            searchText: '',
            loader: false,
            pageOfItems: [],
            userId: '',
            userName: '',
            copiedParamsIndex: null,
        };
        this.handleSearchFilter = this.handleSearchFilter.bind(this);
        this.handleCalendar = this.handleCalendar.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
    }

    componentDidMount() {
        var Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        var userId = Usermeta_Data.split(':')[0];
        var userName = Usermeta_Data.split(':')[1];
        this.setState({ userId: userId, userName: userName }, () => {
            this.fetchUsageLogs(this.state.startDate, this.state.endDate);
        });
    }

    fetchUsageLogs(startDate, endDate) {
        this.setState({ loader: true, usageList: [], usageListTemp: [], pageOfItems: [] });
        try {
            var fromDate = new moment(new Date(startDate)).format("YYYY-MM-DD");
            var toDate = new moment(new Date(endDate)).format("YYYY-MM-DD");
            var { userId, userName } = this.state;
            userService.GetUsageLogs(userId, userName, fromDate, toDate)
                .then(apidata => {
                    this.setState({ loader: false });
                    if (apidata && apidata.length > 0) {
                        this.setState({ usageList: apidata, usageListTemp: apidata });
                    } else {
                        this.setState({ usageList: [], usageListTemp: [] });
                    }
                })
                .catch(err => {
                    console.error(err);
                    this.setState({ loader: false, usageList: [], usageListTemp: [] });
                });
        } catch (err) {
            console.error(err);
            this.setState({ loader: false });
        }
    }

    handleCalendar(e, picker) {
        var changedStartDate = new moment(picker.startDate).format("MM/DD/YYYY");
        var changedEndDate = new moment(picker.endDate).format("MM/DD/YYYY");
        this.setState({ searchText: '', startDate: changedStartDate, endDate: changedEndDate }, () => {
            this.fetchUsageLogs(changedStartDate, changedEndDate);
        });
    }

    handleSearchFilter(val, e) {
        try {
            var { usageListTemp } = this.state;
            var searchText = '';
            if (e === undefined) {
                searchText = val;
            } else {
                searchText = e.target.value;
            }

            var filtered = usageListTemp.filter(function (r) {
                var s = searchText.toLowerCase();
                return (
                    (r.endpoint && r.endpoint.toLowerCase().indexOf(s) !== -1) ||
                    (r.fullUrl && r.fullUrl.toLowerCase().indexOf(s) !== -1) ||
                    (r.actorContext && r.actorContext.toLowerCase().indexOf(s) !== -1) ||
                    (r.actionCategory && r.actionCategory.toLowerCase().indexOf(s) !== -1) ||
                    (r.requestParams && r.requestParams.toLowerCase().indexOf(s) !== -1) ||
                    (r.clientIp && r.clientIp.toLowerCase().indexOf(s) !== -1)
                );
            });

            if (filtered.length > 0) {
                this.setState({ usageList: filtered });
            } else {
                if (searchText.length === 0) {
                    this.setState({ usageList: usageListTemp });
                } else {
                    this.setState({ usageList: [] });
                }
            }
        } catch (err) {}
    }

    onChangePage(pageOfItems) {
        try {
            this.setState({ pageOfItems: pageOfItems });
        } catch (err) {}
    }

    parseRequestParam(params, key) {
        if (!params) return '-';
        try {
            var obj = JSON.parse(params);
            if (typeof obj === 'object' && obj !== null && obj[key] !== undefined && obj[key] !== '') {
                return obj[key];
            }
            return '-';
        } catch (e) {
            return '-';
        }
    }

    formatParamsDisplay(params) {
        if (!params || params === '-') return '-';
        try {
            var obj = JSON.parse(params);
            if (typeof obj === 'object' && obj !== null) {
                return Object.entries(obj)
                    .map(([k, v]) => `${k}: ${v}`)
                    .join('  |  ');
            }
            return params;
        } catch (e) {
            return params;
        }
    }

    handlePickerShow = () => {
        // Use MutationObserver on .drp-selected — fires reliably after every date change
        setTimeout(() => {
            var pickerEl = document.querySelector('.daterangepicker');
            if (!pickerEl) return;
            var selectedEl = pickerEl.querySelector('.drp-selected');
            if (!selectedEl) return;

            if (this._rangeObserver) this._rangeObserver.disconnect();

            this._rangeObserver = new MutationObserver(() => {
                // setTimeout(0) ensures we run AFTER the picker re-enables Apply
                setTimeout(() => {
                    var text = (selectedEl.textContent || selectedEl.innerText || '').trim();
                    var sep = ' - ';
                    var idx = text.indexOf(sep);
                    if (idx === -1) return;
                    var startStr = text.substring(0, idx).trim();
                    var endStr = text.substring(idx + sep.length).trim();
                    if (!endStr) {
                        // Only start date picked — reset error
                        this.updatePickerValidation(false);
                        return;
                    }
                    var start = moment(startStr, 'MM/DD/YYYY');
                    var end = moment(endStr, 'MM/DD/YYYY');
                    if (!start.isValid() || !end.isValid()) return;
                    this.updatePickerValidation(end.diff(start, 'days') > 6);
                }, 0);
            });

            this._rangeObserver.observe(selectedEl, {
                childList: true,
                subtree: true,
                characterData: true,
            });
        }, 100);
    }

    handlePickerHide = () => {
        if (this._rangeObserver) {
            this._rangeObserver.disconnect();
            this._rangeObserver = null;
        }
        this.updatePickerValidation(false);
    }

    updatePickerValidation = (isError) => {
        var pickerEl = document.querySelector('.daterangepicker');
        if (!pickerEl) return;
        var applyBtn = pickerEl.querySelector('.applyBtn');
        var btnsBar = pickerEl.querySelector('.drp-buttons');
        var existing = pickerEl.querySelector('.drp-range-error');
        if (existing) existing.remove();
        if (btnsBar) btnsBar.classList.remove('has-range-error');
        if (isError) {
            if (applyBtn) {
                applyBtn.disabled = true;
                applyBtn.classList.add('disabled');
                applyBtn.style.opacity = '0.45';
                applyBtn.style.cursor = 'not-allowed';
                applyBtn.style.pointerEvents = 'none';
            }
            if (btnsBar) {
                var msg = document.createElement('span');
                msg.className = 'drp-range-error';
                msg.textContent = 'You can select maximum 7 days range.';
                btnsBar.appendChild(msg);
                btnsBar.classList.add('has-range-error');
            }
        } else {
            if (applyBtn) {
                applyBtn.disabled = false;
                applyBtn.classList.remove('disabled');
                applyBtn.style.opacity = '';
                applyBtn.style.cursor = '';
                applyBtn.style.pointerEvents = '';
            }
        }
    }

    cleanPickerError = () => {
        this.updatePickerValidation(false);
    }

    copyRequestParams = (text, index) => {
        copy(text);
        this.setState({ copiedParamsIndex: index });
        setTimeout(() => this.setState({ copiedParamsIndex: null }), 2000);
    }

    downloadCSV = () => {
        var { usageListTemp } = this.state;
        var headerLabels = ['Endpoint', 'Full URL', 'Actor Context', 'Action Category', 'Request Params', 'Client IP', 'Logged At'];
        var rows = usageListTemp.map((r) => {
            var cols = [
                r.endpoint || '',
                r.fullUrl || '',
                r.actorContext || '',
                r.actionCategory || '',
                r.requestParams || '',
                r.clientIp || '',
                r.loggedAt ? r.loggedAt.replace('T', ' ') : '',
            ];
            return cols.map(function (v) { return '"' + v.replace(/"/g, '""') + '"'; }).join(',');
        });
        var csv = [headerLabels.join(',')].concat(rows).join('\n');
        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'DashboardUsageAnalytics_' + new moment().format("YYYYMMDD_HHmmss") + '.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    render() {
        var { loader, pageOfItems, usageList } = this.state;
        var disabled = loader;

        return (
            <div>
                <span className="back-button" onClick={this.props.hideDashboardUsageSection}>Back</span>
                <div className="page-heading-row nlsorder_header monthly_comm">
                    <h2>Dashboard Usage Analytics</h2>
                    {loader && <div className="page-loader"></div>}
                </div>
                <div className="header_bard_button userpage_header_bard nlsreportpage_header">
                    <div className="searchbar">
                        <img src={search_icon} alt="" />
                        <input
                            type="text"
                            disabled={disabled}
                            id="UsageSearchInput"
                            className="form-control searchTable searchtextarea"
                            autoComplete="off"
                            name="searchtext"
                            placeholder="Search"
                            onKeyUp={this.handleSearchFilter.bind(this, '')}
                        />
                    </div>
                    <div className="usage-report-right-controls">
                        <div className="nlsreport-datepicker">
                            <div className="same-on">
                                <label>&nbsp;</label>
                                <DateRangePicker
                                    disabled={disabled}
                                    initialSettings={{
                                        startDate: this.state.startDate,
                                        endDate: this.state.endDate,
                                        maxDate: moment()
                                    }}
                                    onApply={this.handleCalendar}
                                    onShow={this.handlePickerShow}
                                    onHide={this.handlePickerHide}
                                    onCancel={this.cleanPickerError}
                                >
                                    <div>
                                        <div className="react-datepicker_input-container first-one">
                                            <input type="text" className="form-control first readonly-attr" readOnly value={this.state.startDate} />
                                        </div>
                                        <div className="react-datepicker_input-container second-one">
                                            <input type="text" className="form-control readonly-attr" readOnly value={this.state.endDate} />
                                        </div>
                                    </div>
                                </DateRangePicker>
                            </div>
                        </div>
                        <a
                            href="javascript:void('0')"
                            className="custom-tooltip usage-export-btn"
                            onClick={disabled || usageList.length === 0 ? undefined : this.downloadCSV}
                            style={{ opacity: disabled || usageList.length === 0 ? 0.4 : 1, pointerEvents: disabled || usageList.length === 0 ? 'none' : 'auto' }}
                        >
                            <img src={exportIcon} className="export_icon" alt="Download CSV" />
                            <span className="hover-tooltip down-report">Download CSV</span>
                        </a>
                    </div>
                </div>

                <div className="tab-content">
                    <div className="new-report">
                        <div className="tabular_box nls_report_table usage_report_table">
                            <div className="table_header user_page user_data main">
                                <div>Endpoint</div>
                                <div>Full URL</div>
                                <div>Actor Context</div>
                                <div>Action Category</div>
                                <div>Request Params</div>
                                <div>Client IP</div>
                                <div>Logged At</div>
                            </div>
                            <div className="table_body">
                                {loader
                                    ? <div className="norecords">Records are loading..</div>
                                    : <>
                                        {pageOfItems && pageOfItems.length
                                            ? pageOfItems.map((row, index) => {
                                                var loggedAt = row.loggedAt ? row.loggedAt.replace('T', ' ') : '-';
                                                var requestParams = row.requestParams || '-';
                                                var paramsDisplay = requestParams !== '-'
                                                    ? requestParams.replace(/\r\n|\r|\n/g, ' ').replace(/\s+/g, ' ').trim()
                                                    : '-';
                                                var isCopied = this.state.copiedParamsIndex === index;
                                                return (
                                                    <div key={index} className="table_row user_page user_data main_data">
                                                        <div>
                                                            {[
                                                                row.endpoint || '-',
                                                                row.fullUrl || '-',
                                                                row.actorContext || '-',
                                                                row.actionCategory || '-',
                                                            ].map((val, ci) => (
                                                                <div key={ci} className="usage-cell">
                                                                    <span className="cell-text">{val}</span>
                                                                    {val !== '-' && <span className="usage-cell-tooltip">{val}</span>}
                                                                </div>
                                                            ))}
                                                            <div
                                                                className={`usage-cell usage-cell-copyable${isCopied ? ' copied' : ''}`}
                                                                onClick={requestParams !== '-' ? () => this.copyRequestParams(requestParams, index) : undefined}
                                                                style={{ cursor: requestParams !== '-' ? 'pointer' : 'default' }}
                                                            >
                                                                <span className="cell-text">{paramsDisplay}</span>
                                                                {requestParams !== '-' && (
                                                                    <span className="usage-cell-tooltip copy-tooltip">
                                                                        {isCopied ? 'Copied!' : requestParams}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            {[
                                                                row.clientIp || '-',
                                                                loggedAt,
                                                            ].map((val, ci) => (
                                                                <div key={ci + 5} className="usage-cell">
                                                                    <span className="cell-text">{val}</span>
                                                                    {val !== '-' && <span className="usage-cell-tooltip">{val}</span>}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                );
                                            })
                                            : <div className="norecords">No record found</div>
                                        }
                                    </>
                                }
                            </div>
                            <Pagination items={usageList} onChangePage={this.onChangePage} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DashboardUsageReport;
